import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { JsonLd } from 'react-schemaorg';
import map from 'lodash/map';
import get from 'lodash/get';
import findIndex from 'lodash/findIndex';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import absoluteUrl from 'helpers/absoluteUrl';
import beautifyNumber from 'helpers/beautifyNumber';
import Link from 'components/link';
import Row, { Col } from 'components/row';
import Slick from 'components/slick-slider';
import Image, { Thumb } from 'components/image';
import YoutubeIframe from 'components/youtube-iframe';
import { iconTypes } from 'components/icon';
// import { HideTelephoneSeo } from 'components/hide-telephone';
// import { AccordionBlock } from 'components/accordion';

import linksBild from 'src-sites/bild/links';
import linksDomik from 'src-sites/domik/links';
import { getImages } from 'src-sites/domik/section-project/get-images';
import { renderSoldData } from 'src-sites/bild/section-project/render-min-price';
import { reliabilityIndexComplex } from 'src-sites/bild/section-project/reliability-index';
import ContactToDeveloper from 'src-sites/bild/section-project/contact-to-developer';
import { getAskDevHeader, getStartAndBuiltYearsTable } from 'src-sites/bild/section-project/render-common';

import translates from '../lc-i18n';

import 'styles/forum/section-lc/_page-lc.scss';

const bemClasses = new Bem('lc');

@I18nHoc(translates())
export default class BlockLC extends Component {
  static propTypes = {
    className: PropTypes.string,
    pageUrl: PropTypes.string,
    data: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.any)
    ]),
    mainDeveloper: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.any)
    ])
  };

  renderImages(data) {
    const { i18n } = this;
    const { forum_title, product, developers, overflight_link } = data;
    const show_developer_logo = get(product, 'addition_fields.show_developer_logo');
    const forum_images = get(data, 'images.others');

    if (!forum_images || !forum_images.length) {
      return (
        <>
          <Image
            {...bemClasses('imgPic')}
            image={{ alt: forum_title, title: forum_title }}
          />
          <JsonLd
            item={{
              '@context': 'https://schema.org',
              '@type': 'ImageObject',
              name: forum_title ? i18n('developerImgAlt', { placeholder: forum_title }) : null,
              description: forum_title ? i18n('developerImgAlt', { placeholder: forum_title }) : null
            }}
          />
        </>
      );
    }

    return (
      <div {...bemClasses('img')}>
        <Slick {...bemClasses('imgPic')}>
          {map(forum_images, (img, index) => (
            <Fragment key={index}>
              <Image
                image={getImages.call(this, img, { alt: forum_title, title: forum_title }).titleImage}
                group="livingComplexPhotos"
              />
              <JsonLd
                item={{
                  '@context': 'https://schema.org',
                  '@type': 'ImageObject',
                  name: forum_title || null,
                  description: forum_title || null,
                  contentUrl: img ? absoluteUrl(`/images/thumb/full/${img}`) : null
                }}
              />
            </Fragment>
          ))}
        </Slick>
        {show_developer_logo && (!!developers && !!developers.length) &&
          <div {...bemClasses('avaDevelopers')}>
            {map(developers, (it, key) => (
              <div {...bemClasses('imgContainer')} key={key}>
                <div {...bemClasses('img')}>
                  <Thumb
                    {...bemClasses('imgPic')}
                    image={{ id: it.avatar }}
                  />
                </div>
              </div>
            ))}
          </div>
        }
        {overflight_link && this.renderOverflight(overflight_link)}
      </div>
    );
  }

  renderLabel(label) {
    return (
      <td {...bemClasses('text', 'label')}>
        <span children={label} />
      </td>
    );
  }

  renderLinkCard(title, url, builder = null) {
    if (!url && !builder) return null;

    const linkProps = {};

    if (builder) {
      linkProps.builder = builder;
      linkProps.builderProps = { url, title: title };
      linkProps.noRedirector = true;
    }
    if (url) {
      linkProps.href = url;
      linkProps.rel = 'nofollow';
    }

    return (
      <Link
        {...bemClasses('link', 'block')}
        title={title}
        external
        blank
        {...linkProps}
      >
        <span {...bemClasses('linkContent')}>
          <span {...bemClasses('text', 'link')} children={title} />
        </span>
      </Link>
    );
  }

  renderLinkForumDeveloper(title, url) {
    if (!url) return null;

    return (
      <Link
        {...bemClasses('link', 'block')}
        title={title}
        href={url}
        external
        noRedirector
      >
        <span {...bemClasses('linkContent')}>
          <span {...bemClasses('text', 'link')} children={title} />
        </span>
      </Link>
    );
  }

  renderLinkToDomik(title, url) {
    if (!url) return null;

    return (
      <Link
        {...bemClasses('link', 'block')}
        external
        builder={linksDomik.sectionLanding}
        builderProps={{ url, title: title }}
        noRedirector
      >
        <span {...bemClasses('linkContent')}>
          <span {...bemClasses('text', 'link')} children={title} />
        </span>
      </Link>
    );
  }

  renderOverflight =(link)=> {
    const { i18n } = this;

    return (
      <YoutubeIframe
        className={bemClasses}
        videoId={link}
        otherProps={{
          btnToVideoProps: {
            label: i18n('overflight'),
            title: i18n('overflight'),
            iconType: iconTypes.overflight
          }
        }}
      />
    );
  }

  render() {
    const { i18n } = this;
    const data = get(this, 'props.data[0]') || get(this, 'props.data') || {};
    const pageUrl = get(this, 'props.pageUrl');
    const {
      min_price, points, developers, url, url_planirovki,
      id, free_taxi, product, bildcontrol_url, overflight_link
    } = data;
    const showLcBlock = get(product, 'addition_fields.topic_lc');
    const landingLc = get(this, 'props.landingLc.landingLc.data');
    const indexContacts = findIndex(landingLc, (land) => land.subgroup === 'contacts');
    const domikContactsUrl = indexContacts > -1 ?
      get(landingLc, `[${indexContacts}].url`) : null;
    const indexNews = findIndex(landingLc, (land) => land.subgroup === 'news');
    const domikNewsUrl = indexNews > -1 ?
      get(landingLc, `[${indexNews}].url`) : null;
    const { className, mainDeveloper = {} } = this.props;
    const forumDeveloperUrl = get(mainDeveloper, 'url_forum');
    const start_year = get(data, 'advanced_info.start_year.val');
    const built_year = get(data, 'advanced_info.built_year.val');
    const complex_site = get(data, 'advanced_info.complex_sites.val[0]');
    const page_on_lun = get(data, 'advanced_info.page_on_lun.val[0]');
    const salers = get(data, 'salers');
    const indexPhone = findIndex(salers, (saler) => saler.parent === mainDeveloper.id);
    const salerPhone = get(salers, `[${indexPhone}].phones[0]`);
    const salerEmail = get(salers, `[${indexPhone}].contact_email`);
    const askDevHeader = getAskDevHeader.call(this, bemClasses, data);
    const status_ready = get(data, 'status_ready');
    // const phoneSeller = get(data, 'salers[0].phones[0]');

    return (
      <div {...bemClasses({ extra: className })}>
        {/*<AccordionBlock
          {...bemClasses('accordion')}
          panelTopic=""
          dataView="viewBlockOnlyBtn"
          trackAs={`lc-${data.id}`}
        >*/}
        {showLcBlock &&
          <Row {...bemClasses('row', 'main')} allColumn>
            <Col {...bemClasses('col', 'img')} allPr={0}>
              {this.renderImages(data)}
              {overflight_link && this.renderOverflight(overflight_link)}
            </Col>
            <Col {...bemClasses('col', 'info')} allPr={0}>
              <table {...bemClasses('table')}>
                <tbody {...bemClasses('tableBody', 'rowCol')}>
                  {!!developers && !!developers.length &&
                    <tr {...bemClasses('item', 'developers')}>
                      {this.renderLabel(i18n('developer'))}
                      <td {...bemClasses('text', 'info')}>
                        {map(developers, (it, key) =>
                          <Fragment key={key}>
                            <Link
                              {...bemClasses('link', 'developer')}
                              builder={linksDomik.sectionLanding}
                              builderProps={{ url: it.url, title: it.name_short }}
                              title={it.name_short}
                              noRedirector
                            >
                              <span {...bemClasses('linkContent')}>
                                <span {...bemClasses('text')} children={it.name_short} />
                              </span>
                            </Link>
                            {developers.length !== key + 1 && ', '}
                          </Fragment>
                        )}
                      </td>
                    </tr>
                  }
                  {(start_year || built_year) &&
                    getStartAndBuiltYearsTable.call(this, bemClasses, start_year, built_year)
                  }
                  <tr {...bemClasses('item', 'price')}>
                    <td {...bemClasses('text', 'label')}>
                      <Link
                        {...bemClasses('link', 'plans')}
                        builder={linksDomik.sectionLanding}
                        builderProps={{ url: url_planirovki, title: i18n('plans') }}
                        title={i18n('plans')}
                        noRedirector
                      >
                        <span {...bemClasses('linkContent')}>
                          <span {...bemClasses('text')} children={i18n('plans')} />
                        </span>
                      </Link>
                    </td>
                    <td {...bemClasses('text', 'info')}>
                      {renderMinPrice.call(this, bemClasses, min_price, {}, '')}
                    </td>
                  </tr>
                </tbody>
              </table>
              <ContactToDeveloper
                free_taxi={free_taxi}
                developer={mainDeveloper}
                salerEmail={salerEmail}
                salerPhone={salerPhone}
                projectId={id}
                projectUrl={pageUrl}
                askDevHeader={askDevHeader}
                otherPropsDD={{ btnText: i18n('connectConsult') }}
              />
            </Col>
          </Row>
        }
        {/*</AccordionBlock>*/}
        {(domikContactsUrl || domikNewsUrl || forumDeveloperUrl) &&
          <Row {...bemClasses('row', 'blocks links')}>
            <Col {...bemClasses('col', 'blocks')} allFlex allPr={0}>
              {this.renderLinkToDomik(i18n('domikNews'), domikNewsUrl)}
              {this.renderLinkToDomik(i18n('domikContacts'), domikContactsUrl)}
              {this.renderLinkForumDeveloper(i18n('forumDeveloper'), forumDeveloperUrl)}
            </Col>
          </Row>
        }
        <Row {...bemClasses('row', 'blocks')}>
          <Col {...bemClasses('col', 'blocks')} allFlex allPr={0}>
            {this.renderLinkToDomik(i18n('domikCard'), url)}
            {this.renderLinkCard(i18n('lunCard'), page_on_lun)}
            {this.renderLinkCard(i18n('lcSite'), complex_site)}
          </Col>
          <Col {...bemClasses('col', 'reliability')} allPr={0}>
            <div {...bemClasses('blockReliability')}>
              <Row {...bemClasses('row')}>
                {!status_ready &&
                  <Col {...bemClasses('col', 'topic')} allPr={0}>
                    <div>
                      <span {...bemClasses('text', 'topic')} children={i18n('newBuildingReliabilityIndex')} />
                    </div>
                  </Col>
                }
                <Col {...bemClasses('col', 'points')} allAuto allPr={0}>
                  {reliabilityIndexComplex.call(
                    this,
                    bemClasses,
                    points,
                    get(data, 'type'),
                    status_ready
                  )}
                </Col>
              </Row>
              <Link
                {...bemClasses('link', 'fill')}
                builder={linksBild.sectionLanding}
                builderProps={{ url: bildcontrol_url, title: i18n('plans') }}
                noRedirector
                external
                blank
                children={<span {...bemClasses('linkContent')} />}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

function renderMinPrice(bemClasses, min_price, soldData = {}, sales_suspended_until) {
  const soldOrSuspendedTxt = renderSoldData.call(this, bemClasses, soldData, sales_suspended_until);

  if (soldOrSuspendedTxt && bemClasses) return <div {...bemClasses('price')} children={soldOrSuspendedTxt} />;
  if (!min_price) return null;

  const priceCurrencyName = min_price.currency.id === 'uah' ?
    min_price.currency.name_short :
    min_price.currency.names_long;
  const priceClassDisplayName = min_price.class.displayName || '';
  const priceCurrency = `${priceCurrencyName}${priceClassDisplayName}`;
  const priceBeginText = this.i18n('priceBeginText');
  const priceMain = beautifyNumber(min_price.value);

  if (!bemClasses) return `${priceBeginText} ${priceMain} ${priceCurrency}`;

  const priceFullText = (min_price && min_price.value && min_price.currency && min_price.class) ?
    <span {...bemClasses('text', 'price')} children={`${priceBeginText} ${priceMain} ${priceCurrency}`} /> :
    null;

  return <div {...bemClasses('price')} children={priceFullText} />;
}
